import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "font-sans font-bold break-normal text-gray-700 px-2 pb-2" }, " サロンジャック登録 ", -1)
const _hoisted_2 = { class: "p-2 mt-2 lg:mt-0 rounded shadow bg-white" }
const _hoisted_3 = { class: "p-6" }
const _hoisted_4 = { class: "mb-2 last:mb-0" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "text-xs text-pink-600" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "text-xs text-pink-600" }
const _hoisted_11 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = { class: "text-xs text-pink-600" }
const _hoisted_14 = { class: "p-2 mt-2 rounded shadow bg-white" }
const _hoisted_15 = { class: "p-6" }
const _hoisted_16 = { class: "mb-2 last:mb-0" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "block mb-2" }, "条件", -1)
const _hoisted_18 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_19 = { class: "relative" }
const _hoisted_20 = { class: "text-xs text-pink-600" }
const _hoisted_21 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_22 = { class: "relative" }
const _hoisted_23 = { class: "text-xs text-pink-600" }
const _hoisted_24 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_25 = { class: "relative" }
const _hoisted_26 = { class: "text-xs text-pink-600" }
const _hoisted_27 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_28 = { class: "relative" }
const _hoisted_29 = { class: "text-xs text-pink-600" }
const _hoisted_30 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_31 = { class: "relative" }
const _hoisted_32 = { class: "text-xs text-pink-600" }
const _hoisted_33 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_34 = { class: "relative" }
const _hoisted_35 = { class: "text-xs text-pink-600" }
const _hoisted_36 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_37 = { class: "relative" }
const _hoisted_38 = { class: "text-xs text-pink-600" }
const _hoisted_39 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_40 = { class: "relative" }
const _hoisted_41 = { class: "text-xs text-pink-600" }
const _hoisted_42 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_43 = { class: "relative" }
const _hoisted_44 = { class: "text-xs text-pink-600" }
const _hoisted_45 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_46 = { class: "relative" }
const _hoisted_47 = { class: "text-xs text-pink-600" }
const _hoisted_48 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_49 = { class: "relative" }
const _hoisted_50 = { class: "text-xs text-pink-600" }
const _hoisted_51 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_52 = { class: "relative" }
const _hoisted_53 = { class: "text-xs text-pink-600" }
const _hoisted_54 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_55 = { class: "relative" }
const _hoisted_56 = { class: "text-xs text-pink-600" }
const _hoisted_57 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_58 = { class: "relative" }
const _hoisted_59 = { class: "text-xs text-pink-600" }
const _hoisted_60 = { class: "grid grid-cols-1 gap-3 mt-2" }
const _hoisted_61 = { class: "relative" }
const _hoisted_62 = { class: "text-xs text-pink-600" }
const _hoisted_63 = { class: "text-right col-span-full mt-4" }
const _hoisted_64 = ["onClick"]

import { useField, useForm } from "vee-validate";
import * as yup from "yup";

import JackRequest from "@/models/JackRequest";
import { useStore } from "vuex";

import moment from "moment";
import { onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'JackRequestEdit',
  setup(__props) {

const store = useStore();
const route = useRoute();
const router = useRouter();

const formSchema = yup.object({
  title: yup.string().required("必須項目です"),
  artifact: yup.string().required("必須項目です"),
  replyment_deadline: yup.string().required("必須項目です"),
  condition1: yup.string(),
  condition2: yup.string(),
  condition3: yup.string(),
  condition4: yup.string(),
  condition5: yup.string(),
  condition6: yup.string(),
  condition7: yup.string(),
  condition8: yup.string(),
  condition9: yup.string(),
  condition10: yup.string(),
  condition11: yup.string(),
  condition12: yup.string(),
  condition13: yup.string(),
  condition14: yup.string(),
  condition15: yup.string(),
});

useForm({ validationSchema: formSchema });

const title_field = useField<string>("title");
const artifact_field = useField<string>("artifact");
const replyment_deadline_field = useField<string>("replyment_deadline");
const condition1_field = useField<string>("condition1");
const condition2_field = useField<string>("condition2");
const condition3_field = useField<string>("condition3");
const condition4_field = useField<string>("condition4");
const condition5_field = useField<string>("condition5");
const condition6_field = useField<string>("condition6");
const condition7_field = useField<string>("condition7");
const condition8_field = useField<string>("condition8");
const condition9_field = useField<string>("condition9");
const condition10_field = useField<string>("condition10");
const condition11_field = useField<string>("condition11");
const condition12_field = useField<string>("condition12");
const condition13_field = useField<string>("condition13");
const condition14_field = useField<string>("condition14");
const condition15_field = useField<string>("condition15");

const title = title_field.value;
const title_error = title_field.errorMessage;

const artifact = artifact_field.value;
const artifact_error = artifact_field.errorMessage;

const replyment_deadline = replyment_deadline_field.value;
const replyment_deadline_error = replyment_deadline_field.errorMessage;

const condition1 = condition1_field.value;
const condition1_error = condition1_field.errorMessage;

const condition2 = condition2_field.value;
const condition2_error = condition2_field.errorMessage;

const condition3 = condition3_field.value;
const condition3_error = condition3_field.errorMessage;

const condition4 = condition4_field.value;
const condition4_error = condition4_field.errorMessage;

const condition5 = condition5_field.value;
const condition5_error = condition5_field.errorMessage;

const condition6 = condition6_field.value;
const condition6_error = condition6_field.errorMessage;

const condition7 = condition7_field.value;
const condition7_error = condition7_field.errorMessage;

const condition8 = condition8_field.value;
const condition8_error = condition8_field.errorMessage;

const condition9 = condition9_field.value;
const condition9_error = condition9_field.errorMessage;

const condition10 = condition10_field.value;
const condition10_error = condition10_field.errorMessage;

const condition11 = condition11_field.value;
const condition11_error = condition11_field.errorMessage;

const condition12 = condition12_field.value;
const condition12_error = condition12_field.errorMessage;

const condition13 = condition13_field.value;
const condition13_error = condition13_field.errorMessage;

const condition14 = condition14_field.value;
const condition14_error = condition14_field.errorMessage;

const condition15 = condition15_field.value;
const condition15_error = condition15_field.errorMessage;

const jackrequest = ref<JackRequest | null>(null);

onMounted(() => {
  refresh();
});

const refresh = () => {
  if (store.state.is_loading) {
    return;
  }

  const id = route.params.jack_request_id as string | null;

  store.dispatch("setLoading", true);

  setTimeout(async () => {
    try {
      if (!id) {
        return;
      }
      jackrequest.value = await JackRequest.get(id);

      title.value = jackrequest.value.title;
      artifact.value = jackrequest.value.article;
      if (jackrequest.value.replyment_deadline) {
        const date = jackrequest.value.replyment_deadline as Date;
        replyment_deadline.value = moment(date).format("YYYY-MM-DD");
      }
      condition1.value = jackrequest.value.condition1 ?? "";
      condition2.value = jackrequest.value.condition2 ?? "";
      condition3.value = jackrequest.value.condition3 ?? "";
      condition4.value = jackrequest.value.condition4 ?? "";
      condition5.value = jackrequest.value.condition5 ?? "";
      condition6.value = jackrequest.value.condition6 ?? "";
      condition7.value = jackrequest.value.condition7 ?? "";
      condition8.value = jackrequest.value.condition8 ?? "";
      condition9.value = jackrequest.value.condition9 ?? "";
      condition10.value = jackrequest.value.condition10 ?? "";
      condition11.value = jackrequest.value.condition11 ?? "";
      condition12.value = jackrequest.value.condition12 ?? "";
      condition13.value = jackrequest.value.condition13 ?? "";
      condition14.value = jackrequest.value.condition14 ?? "";
      condition15.value = jackrequest.value.condition15 ?? "";
    } finally {
      store.dispatch("setLoading", false);
    }
  });
};

const validate = async  (): Promise<boolean> => {
  await title_field.validate();
  await artifact_field.validate();
  await replyment_deadline_field.validate();
  await condition1_field.validate();
  await condition2_field.validate();
  await condition3_field.validate();
  await condition4_field.validate();
  await condition5_field.validate();
  await condition6_field.validate();
  await condition7_field.validate();
  await condition8_field.validate();
  await condition9_field.validate();
  await condition10_field.validate();
  await condition11_field.validate();
  await condition12_field.validate();
  await condition13_field.validate();
  await condition14_field.validate();
  await condition15_field.validate();

  return (
    !title_error.value &&
    !artifact_error.value &&
    !replyment_deadline_error.value &&
    !condition1_error.value &&
    !condition2_error.value &&
    !condition3_error.value &&
    !condition4_error.value &&
    !condition5_error.value &&
    !condition6_error.value &&
    !condition7_error.value &&
    !condition8_error.value &&
    !condition9_error.value &&
    !condition10_error.value &&
    !condition11_error.value &&
    !condition12_error.value &&
    !condition13_error.value &&
    !condition14_error.value &&
    !condition15_error.value
  );
};

const onSave = () => {
  if (store.state.is_loading) {
    return;
  }

  store.dispatch("setLoading", true);
  setTimeout(async () => {
    try {
      const valid = await validate();
      if (!valid) {
        return;
      }

      if (!jackrequest.value) {
        await JackRequest.register(
          title.value,
          artifact.value,
          condition1.value,
          condition2.value,
          condition3.value,
          condition4.value,
          condition5.value,
          condition6.value,
          condition7.value,
          condition8.value,
          condition9.value,
          condition10.value,
          condition11.value,
          condition12.value,
          condition13.value,
          condition14.value,
          condition15.value,
          moment(replyment_deadline.value).toDate()
        );
      } else {
        await JackRequest.update(
          jackrequest.value.id,
          title.value,
          artifact.value,
          condition1.value,
          condition2.value,
          condition3.value,
          condition4.value,
          condition5.value,
          condition6.value,
          condition7.value,
          condition8.value,
          condition9.value,
          condition10.value,
          condition11.value,
          condition12.value,
          condition13.value,
          condition14.value,
          condition15.value,
          moment(replyment_deadline.value).toDate()
        );
      }
      router.push(`/jackrequests`);
    } finally {
      store.dispatch("setLoading", false);
    }
  });
  console.log(this);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(title_error) }]),
                placeholder: "タイトル",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(title) ? (title).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(title)]
              ]),
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(title_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("textarea", {
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-48 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(artifact_error) }]),
                placeholder: "メッセージ",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(artifact) ? (artifact).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(artifact)]
              ]),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(artifact_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                type: "date",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(replyment_deadline_error) }]),
                placeholder: "回答期限",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(replyment_deadline) ? (replyment_deadline).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(replyment_deadline)]
              ]),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(replyment_deadline_error)), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition1_error) }]),
                placeholder: "条件1",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(condition1) ? (condition1).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition1)]
              ]),
              _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(condition1_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition2_error) }]),
                placeholder: "条件2",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(condition2) ? (condition2).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition2)]
              ]),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(condition2_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition3_error) }]),
                placeholder: "条件3",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(condition3) ? (condition3).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition3)]
              ]),
              _createElementVNode("span", _hoisted_26, _toDisplayString(_unref(condition3_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition4_error) }]),
                placeholder: "条件4",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_isRef(condition4) ? (condition4).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition4)]
              ]),
              _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(condition4_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition5_error) }]),
                placeholder: "条件5",
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(condition5) ? (condition5).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition5)]
              ]),
              _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(condition5_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition6_error) }]),
                placeholder: "条件6",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(condition6) ? (condition6).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition6)]
              ]),
              _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(condition6_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition7_error) }]),
                placeholder: "条件7",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(condition7) ? (condition7).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition7)]
              ]),
              _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(condition7_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition8_error) }]),
                placeholder: "条件8",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_isRef(condition8) ? (condition8).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition8)]
              ]),
              _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(condition8_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition9_error) }]),
                placeholder: "条件9",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(condition9) ? (condition9).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition9)]
              ]),
              _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(condition9_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition10_error) }]),
                placeholder: "条件10",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(condition10) ? (condition10).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition10)]
              ]),
              _createElementVNode("span", _hoisted_47, _toDisplayString(_unref(condition10_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition11_error) }]),
                placeholder: "条件11",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_isRef(condition11) ? (condition11).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition11)]
              ]),
              _createElementVNode("span", _hoisted_50, _toDisplayString(_unref(condition11_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition12_error) }]),
                placeholder: "条件12",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_isRef(condition12) ? (condition12).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition12)]
              ]),
              _createElementVNode("span", _hoisted_53, _toDisplayString(_unref(condition12_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition13_error) }]),
                placeholder: "条件13",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(condition13) ? (condition13).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition13)]
              ]),
              _createElementVNode("span", _hoisted_56, _toDisplayString(_unref(condition13_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition14_error) }]),
                placeholder: "条件14",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(condition14) ? (condition14).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition14)]
              ]),
              _createElementVNode("span", _hoisted_59, _toDisplayString(_unref(condition14_error)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["px-3 py-2 max-w-full focus:outline-none border-gray-200 rounded w-full dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800", { 'border-pink-600': _unref(condition15_error) }]),
                placeholder: "条件15",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(condition15) ? (condition15).value = $event : null))
              }, null, 2), [
                [_vModelText, _unref(condition15)]
              ]),
              _createElementVNode("span", _hoisted_62, _toDisplayString(_unref(condition15_error)), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_63, [
      _createElementVNode("button", {
        class: "shadow bg-yellow-700 hover:bg-yellow-500 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded",
        type: "button",
        onClick: _withModifiers(onSave, ["prevent"])
      }, " 登録 ", 8, _hoisted_64)
    ])
  ], 64))
}
}

})